import { ErrorMessage } from "../../Constants/Messages";
import { FieldTypeEnum } from '../Enums/FieldEnum';
import { InvalidNumbers } from '../Enums/InvalidValueEnums';

export const RequiredFieldHelper = {
    validateForm: function (requiredParams: any, formParams: any, errorMessages: any, setErrorMessages: any = null, enqueueSnackbar: any = null) {
        let _validateFields = this.validateFields(requiredParams, formParams, {});
        let tempErrorMessages = _validateFields.errorMessages;
        let _hasError = _validateFields.hasError;
        let _formParams = _validateFields.formParams;

        setErrorMessages({ ...tempErrorMessages });

        if (_hasError) {
            enqueueSnackbar(ErrorMessage.FIELD_REQUIRED, { variant: 'error' });
        }

        return { hasError: _hasError, formParams: _formParams };
    },
    validateFields: function (requiredParams: any, formParams: any, errorMessages: any, hasIndex: boolean = false, indexNum: any = 0) {
        let tempErrorMessages = { ...errorMessages };
        let _formParams = { ...formParams };
        let _hasError = false;

        for (const [key, value] of Object.entries(requiredParams)) {
            switch (requiredParams[key].type) {
                case FieldTypeEnum.DATERANGE:
                    const emptyStartDate = this.validateDates(formParams[requiredParams[key].startKey]);
                    const emptyStartEnd = this.validateDates(formParams[requiredParams[key].endKey]);

                    if (!emptyStartDate && !emptyStartEnd) {
                        const validateDateRange = this.validateDateRanges(formParams[requiredParams[key].startKey], formParams[requiredParams[key].endKey]);

                        tempErrorMessages[requiredParams[key].keyName + (hasIndex ? indexNum : "")] = validateDateRange ? ErrorMessage.NOT_LATER_THAN_START_DATE : '';

                        if (validateDateRange && !_hasError) {
                            _hasError = true;
                        }
                    } else {
                        tempErrorMessages[requiredParams[key].keyName + (hasIndex ? indexNum : "")] = (requiredParams[key].labelName + ErrorMessage.IS_REQUIRED);

                        if (!_hasError) {
                            _hasError = true;
                        }
                    }
                    break;

                case FieldTypeEnum.OBJECT:
                    let _objectData = formParams[requiredParams[key].keyName];
                    let _requiredItems = requiredParams[key].fields;

                    let _validate: any = this.validateFields(_requiredItems, _objectData, { ...tempErrorMessages });

                    tempErrorMessages = { ..._validate.errorMessages };

                    if (!_hasError) {
                        _hasError = _validate?.hasError ?? false;
                    }
                    
                    break;

                case FieldTypeEnum.OBJECTARRAY:
                    let _objectArray = formParams[requiredParams[key].keyName];
                    let _oArray = [];
                    let _requiredFields = requiredParams[key].fields;
                    let _fieldLength = _objectArray?.length ?? 0;


                    if (requiredParams[key].onlyIfHadValues && _fieldLength > 0) {
                        for (const [objKey, objValue] of Object.entries(_objectArray)) {
                            let _proceed = false;

                            for (const [rfKey, rfValue] of Object.entries(_requiredFields)) {
                                if (_objectArray[objKey][_requiredFields[rfKey].keyName] || _objectArray[objKey][_requiredFields[rfKey].startKey] || _objectArray[objKey][_requiredFields[rfKey].endKey]) {
                                    _proceed = true;
                                    break;
                                }
                            }

                            if (_proceed) {
                                _oArray.push(_objectArray[objKey]);
                            }
                        }

                        if (_oArray.length > 0) {
                            for (const oaKey in Object.entries(_oArray)) {
                                let _validateData = this.validateFields(_requiredFields, _oArray[oaKey], { ...tempErrorMessages }, true, oaKey);

                                tempErrorMessages = { ..._validateData.errorMessages };

                                if (!_hasError && _validateData.hasError) {
                                    _hasError = true;
                                }
                            }
                        }

                        _formParams[requiredParams[key].keyName] = _oArray;
                    }
                    break;

                case FieldTypeEnum.ARRAY:
                    let _arrayData = formParams[requiredParams[key].keyName] ?? [];
                    let _isEmpty = _arrayData?.length <= 0;

                    if(_isEmpty) {
                        tempErrorMessages[requiredParams[key].keyName] = ErrorMessage.SELECT_ATLEAST_ONE + requiredParams[key].labelName?.toLowerCase();

                        if (!_hasError) {
                            _hasError = true;
                        }
                    }
                    break;

                // case FieldTypeEnum.STRING:
                case FieldTypeEnum.NUMBER:
                    let _value: any = isNaN(parseFloat(formParams[requiredParams[key].keyName])) ? 0 : parseFloat(formParams[requiredParams[key].keyName]);
                    let _emptyNumberValue = this.validateStringAndNumbers(formParams[requiredParams[key].keyName]);
                    
                    if(InvalidNumbers.includes(requiredParams[key].keyName) && !_emptyNumberValue) {
                        _emptyNumberValue = _value <= 0;
                        tempErrorMessages[requiredParams[key].keyName + (hasIndex ? indexNum : "")] = _emptyNumberValue ? (ErrorMessage.INVALID + ' ' + requiredParams[key].labelName) : '';
                    } else {
                         tempErrorMessages[requiredParams[key].keyName + (hasIndex ? indexNum : "")] = _emptyNumberValue ? (requiredParams[key].labelName + ErrorMessage.IS_REQUIRED) : '';
                    }

                    if (_emptyNumberValue && !_hasError) {
                        _hasError = true;
                    }

                    break;

                case FieldTypeEnum.EMAIL:
                    let emptyEmail = this.validateStringAndNumbers(formParams[requiredParams[key].keyName]);
                    let invalidEmail = false;

                    tempErrorMessages[requiredParams[key].keyName + (hasIndex ? indexNum : "")] = emptyEmail ? (requiredParams[key].labelName + ErrorMessage.IS_REQUIRED) : '';

                    if(!emptyEmail) {
                        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
                        
                        invalidEmail = !emailRegex.test(formParams[requiredParams[key].keyName]);

                        if (invalidEmail) {
                            tempErrorMessages[requiredParams[key].keyName + (hasIndex ? indexNum : "")] = ErrorMessage.ENTER_A_VALID + requiredParams[key].labelName;
                        }
                    }
                    if ((emptyEmail || invalidEmail) && !_hasError) {
                        _hasError = true;
                    }
                    break;

                default:
                    const emptyValue = this.validateStringAndNumbers(formParams[requiredParams[key].keyName]);

                    tempErrorMessages[requiredParams[key].keyName + (hasIndex ? indexNum : "")] = emptyValue ? (requiredParams[key].labelName + ErrorMessage.IS_REQUIRED) : '';

                    if (emptyValue && !_hasError) {
                        _hasError = true;
                    }
                    break;
            }
        }

        return { errorMessages: tempErrorMessages, hasError: _hasError, formParams: _formParams };
    },
    validateStringAndNumbers: function (formValue: any) {
        return formValue === undefined || formValue === null || formValue === "" || formValue === false || formValue === 0;
    },
    validateDates: function (formValue: any) {
        return formValue === undefined || formValue === null || formValue === "";
    },
    validateDateRanges: function (startDate: any, endDate: any) {
        return endDate < startDate;
    },
}

export default RequiredFieldHelper;